<template>
    <div></div>
</template>

<script>
export default {
    beforeRouteEnter(to, from, next)  {
        next(vm => {
            console.log(from.path, 'fromPath')
            vm.$router.push(from.path);
            // 跳到该路由页面后，再替换为from.path来源路径 
        })
    },
    // beforeCreate() {
    //     debugger
    //     this.$router.push({
    //       path: '/welcome',
    //       query: {
    //         t: Date.now(),
    //       },
    //     });
    // },
}
</script>